import React from "react";
import { Button } from "@hubble/web";

import { Body } from "app/_components/components/Text/Body";
import { buildContentfulImageUrl } from "components/common/utils/contentful-utils";

interface SmallPriceCardProps {
  title: string;
  description?: string;
  CTALabel?: string;
  bgStyles?: React.CSSProperties;
  imageUrl?: string;
  imageContainerClasses?: string;
  imageClasses?: string;
}

function SmallPriceCard({
  title,
  description,
  CTALabel,
  imageUrl = "",
  imageClasses,
  imageContainerClasses,
  bgStyles = {}
}: SmallPriceCardProps) {
  return (
    <div className="flex flex-col overflow-hidden rounded-2xl bg-[#F7F7F7] [@media(max-width:709px)]:mb-[48px] [@media(min-width:710px)]:hidden [@media(min-width:904px)]:flex">
      <div style={{ ...bgStyles }}>
        <div className={imageContainerClasses}>
          <img
            width={232}
            className={imageClasses}
            src={buildContentfulImageUrl(imageUrl, "webp", 85)}
            alt="reward card"
          />
        </div>
      </div>
      <div className="flex flex-col gap-[20px] p-[24px]">
        <div>
          <Body
            size="xl"
            className="!mb-[8px] leading-[24px] font-semibold tracking-[-0.5px]"
          >
            {title}
          </Body>
          <Body size="sm" className="mt-2 leading-[20px] font-normal">
            {description}
          </Body>
        </div>
        <div className="mt-[8px] flex w-full flex-row gap-4 [@media(max-width:710px)]:flex-col">
          <Button.Secondary
            role="link"
            target="_blank"
            href="https://www.gemini.com/referral-club"
            className="w-fit !bg-[#F9A631] !px-[16px] !py-[10px] text-[#F9A631] hover:bg-[rgba(1,3,4,0.12)] hover:text-[#010304]"
          >
            <Body size="sm" className="leading-[16px] font-semibold">
              {CTALabel}
            </Body>
          </Button.Secondary>
        </div>
      </div>
    </div>
  );
}

export default SmallPriceCard;
